// Indique e ganhe (spec 2026-10-11). O link e o de AFILIADO da Hotmart: quem
// rastreia a venda e paga a comissao e a Hotmart; o app so guarda e compartilha.

// Pagina de recrutamento de afiliados do produto CRM na Hotmart. Vazio = o
// botao "Virar afiliado" fica escondido.
// Painel da Hotmart onde o afiliado ve indicacoes e comissoes (atalho do cartao
// "Acompanhe seus resultados"). Endereco geral do painel: a Hotmart leva ao login.
export const PAINEL_HOTMART = 'https://app.hotmart.com/'

export const LINK_AFILIACAO = 'https://affiliate.hotmart.com/affiliate-recruiting/view/0912C108011781'

const LIMITE = 500

export function validarLinkHotmart(texto: string): { ok: true; link: string } | { ok: false } {
  const link = texto.trim()
  if (!link || link.length > LIMITE) return { ok: false }
  let url: URL
  try {
    url = new URL(link)
  } catch {
    return { ok: false }
  }
  if (url.protocol !== 'https:') return { ok: false }
  // Compara o FIM do dominio: "hotmart.com.golpe.net" e "falsohotmart.com" nao passam.
  const host = url.hostname.toLowerCase()
  if (host !== 'hotmart.com' && !host.endsWith('.hotmart.com')) return { ok: false }
  return { ok: true, link }
}

// Vai para o INDICADO: fala do app e do teste gratis, nunca da comissao.
export function mensagemDeIndicacao(link: string): string {
  return 'Oi! Uso o CRM Multimarca para organizar meus pedidos, clientes e comissões de todas as fornecedoras, até sem internet. Recomendo! Dá para testar grátis por 30 dias: ' + link
}

// Mesmo molde de pedidos/compartilhar.ts.
export function linkWhatsApp(link: string): string {
  return `https://wa.me/?text=${encodeURIComponent(mensagemDeIndicacao(link))}`
}
